module.exports = __webpack_public_path__ + "img/dropdown-arrow-top.eff1b666.png";